import { render } from "./gzhPreprintList.vue?vue&type=template&id=0e5db202&scoped=true"
import script from "./gzhPreprintList.vue?vue&type=script&lang=js"
export * from "./gzhPreprintList.vue?vue&type=script&lang=js"

import "./gzhPreprintList.vue?vue&type=style&index=0&id=0e5db202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5db202"]])

export default __exports__